import React, { useEffect, useState } from "react";
// import { TieredMenu } from 'primereact/tieredmenu';
// import { useRouter } from 'next/router';
import "../../assets/styles/layout/leftmenu.scss";
// import type { MenuProps } from 'antd';
import { Button, Menu } from "antd";
import { iconSet, IcomoonReact } from "../PrimeReact.js";
import GV from "../../services/globalVar";
import { NavLink } from "react-router-dom";
import { Tooltip, Tag } from "antd";
import { useLocation } from "react-router-dom"; 

export default function LeftMenuTwo(props) {
  const [menuItems, setMenuItems] = useState([]);
  const location = useLocation();
  let datas = location.state !== null;

  const items = [
    {
      key: "1",
      icon: (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon="inventory"
          className="pointer   px-0 menu-logo"
        />
      ),
      label: "Option 1",
    },
    {
      key: "2",
      icon: (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon="inventory"
          className="pointer   px-0 menu-logo"
        />
      ),
      label: "Option 2",
    },
    {
      key: "3",
      icon: (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon="inventory"
          className="pointer   px-0 menu-logo"
        />
      ),
      label: "Option 3",
    },
    {
      key: "sub1",
      label: "Navigation One",
      icon: (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon="inventory"
          className="pointer   px-0 menu-logo"
        />
      ),
      children: [
        { key: "5", label: "Option 5" },
        { key: "6", label: "Option 6" },
        { key: "7", label: "Option 7" },
        { key: "8", label: "Option 8" },
      ],
    },
    {
      key: "sub2",
      label: "Navigation Two",
      icon: (
        <IcomoonReact
          iconSet={iconSet}
          size={25}
          icon="inventory"
          className="pointer   px-0 menu-logo"
        />
      ),
      children: [
        { key: "9", label: "Option 9" },
        { key: "10", label: "Option 10" },
        {
          key: "sub3",
          label: "Submenu",
          children: [
            { key: "11", label: "Option 11" },
            { key: "12", label: "Option 12" },
          ],
        },
      ],
    },
  ];

  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  async function getMenu() {
    let data = GV.userDet.entService;
    let value = [];
    let z = 0;
    data.forEach((e, i) => {
      let subdiv = [];

      e.subMenu.forEach((x, j) => {
        const sub = {
          key: z,
          label: (
            <NavLink
              to={`${x.resourceAction}`}
              className="d-flex justify-content-start"
              style={{ fontSize: "13px" }}
              key={x.serviceOrder}
            >
              {x.serviceName}
            </NavLink>
          ),
        };
        z = z + 1;
        subdiv.push(sub);
      });
      let label =
        e.resourceAction != "#" ? (
          <NavLink
            to={`${e.resourceAction}`}
            className={({ isActive }) => `d-flex justify-content-center m-1 ${isActive ? 'active-link' : 'inactive-link'}`}
            style={{ fontSize: "0.7rem" }}
            key={e.serviceOrder}
          >
            {e.serviceName}
          </NavLink>
        ) : (
          <span style={{ fontSize: "0.7rem" }} key={e.serviceOrder}>
            <span className="d-flex justify-content-center m-1">
              {e.serviceName}
            </span>
          </span>
        );
      const val = {
        key: z,
        label: label,
        icon: (
          <span className="d-flex justify-content-center mt-2">
            <IcomoonReact
              iconSet={iconSet}
              size={25}
              icon={e.menuIcon}
              className="pointer px-0 menu-logo"
            />
          </span>
        ),
        children: subdiv.length !== 0 ? subdiv : null,
        title: "",
      };
      z = z + 1;
      value.push(val);
    });
    setMenuItems(value);
  }

  function selectMenu(val) {
    localStorage.setItem("menu", val.selectedKeys);
    localStorage.setItem("mainmenu", val.keyPath[1]);
    setActiveMenu(val.selectedKeys[0].toString());
  }

  const [screenwidth, setScreenWidth] = useState(window.innerWidth);
  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("menu")?.toString() || "0");

  useEffect(() => {
    getMenu();
    const val =
      localStorage.getItem("menu") === null ||
      localStorage.getItem("menu") === undefined
        ? localStorage.setItem("menu", 0)
        : "";
  }, []);

  useEffect(() => {
    if (location.state && location.state.selectedKeys && location.state.selectedKeys[0]) {
      let menus = String(location.state.selectedKeys[0]);
      setActiveMenu(menus);
      localStorage.setItem("menu", menus);
      localStorage.setItem("mainmenu", location.state.keyPath[0]);
    }

    const val = 
      localStorage.getItem("menu") === null ||
      localStorage.getItem("menu") === undefined
        ? localStorage.setItem("menu", 0)
        : "";
  }, [datas]);

  return (
    <div
      style={{
        position: "fixed",
        boxShadow: "0 4px 4px #00000040",
        height: "calc(100vh - 67px)",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto",
        }}
      >
        {menuItems.length !== 0 ? (
          <Menu
            className="bx-shadow"
            defaultSelectedKeys={[localStorage.getItem("menu")?.toString()]}
            selectedKeys={[activeMenu]}
            mode="inline"
            theme="light"
            inlineCollapsed={collapsed}
            items={menuItems}
            onSelect={(e) => selectMenu(e)}
          />
        ) : (
          ""
        )}
      </div>

      <div
        style={{
          marginTop: "auto",
          padding: "10px 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tooltip title="Logout">
          <button
            style={{ backgroundColor: "transparent" }}
            onClick={() => {
              localStorage.clear();
              window.location.href = "/";
            }}
          >
            <i className="pi pi-sign-out fw-bold"></i>
          </button>
        </Tooltip>
      </div>
      {/* <div
        style={{
          marginTop: "auto",
          padding: "10px 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tooltip title="Profile">
          <button
            style={{ backgroundColor: "transparent" }}
            onClick={() => {
              localStorage.clear();
              window.location.href = "/";
            }}
          >
            <i className="pi pi-sign-out fw-bold"></i>
          </button>
        </Tooltip>
      </div> */}
    </div>
  );
}
